





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import fetch from '@/common/api/fetch';

import { QuillEditor, IntroItem } from '@/common/interface';
import { isMobile } from '@/common/utils/getPlaform';
import { getInputStyle } from '@/common/utils/getStyles';
import getUrlParam from '@/common/utils/getUrlParam';
import { replaceStringReverse, replaceString } from '@/common/utils/dealWithString';
import ImageUpload from '@/components/common/edit/ImageUpload.vue';
const loadingImage = require('@/assets/img/loadingImage.gif');

@Component({
  components: {
    'image-upload': ImageUpload
  }
})
export default class RuleIntroList extends Vue {
  @Getter('section') section!: any;
  @Getter('activityRule') activityRule!: string;
  @Getter('activityIntros') getterActivityIntros!: Array<IntroItem>;

  @Action('upActivityIntro') upActivityIntro!: Function;
  @Action('downActivityIntro') downActivityIntro!: Function;
  @Action('deleteActivityIntro') deleteActivityIntro!: Function;
  @Action('changeActivityIntros') changeActivityIntros!: Function;

  isMobile: Function = isMobile;
  replaceString: Function = replaceString;
  loadingImage: string = loadingImage;
  type: string = getUrlParam("type") as string;

  get activityIntros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    const len: number = this.getterActivityIntros.length;
    for (let i: number = 0; i < len; i++) {
      const item: IntroItem = Object.assign(this.getterActivityIntros[i]);
      item.value = item.value && replaceStringReverse(item.value);
      tempArray.push(item);
    }
    return tempArray;
  }
  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section;
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }
  get TiLength() {
    return 0
  }
  onEditorChange(event: QuillEditor, index: number) {
    // 限制1000个字符
    if ((event.quill.getLength() - 1) > 1000) {
      event.quill.deleteText(1000,1);
      return 
    }

    this.changeActivityIntros({
      index,
      value: event.html
    });
  }
  // 上移项目
  handleUpItem(index: number) {
    this.upActivityIntro(index);
  }
  // 下移项目
  handleDownItem(index: number) {
    this.downActivityIntro(index);
  }
  // 删除项目
  handleDeleteIntroItem(index: number): void {
    Vue.$confirm({
      text: '确定删除吗',
      ok: () => {
        this.deleteActivityIntro(index);
        Vue.$toast.success('删除成功！');
      }
    });
  }
  // 替换图片
  handleReplaceImg(imgUrl: string, index: number) {
    this.changeActivityIntros({ index, value: imgUrl });
  }

  handleVideo(item: any) {
    if (this.type === 'edit') {
      return;
    }
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: 'video',
        query: query
      });
    });
  }
}
